import React from 'react'
import './professionals-services.css'
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

const Professionals = () => {
    return (
        <div>
            <div className='service-professional'>
                <div className='service-professional-list'>
                    <ul>
                        <li class="active">Corte masculino</li>
                        <li>Barba</li>
                        <li>Corte + Barba</li>
                        <li>Sobranchelha</li>
                    </ul>
                </div>
                <div className='service-professional-list'>
                    <ul>
                        <li class="active">Humberto</li>
                        <li>Frederico</li>
                        <li>Marcos</li>
                        <li>Figueredo</li>
                    </ul>
                </div>
            </div>

            <div className="date-booking">
                <HiChevronLeft className="icon" />
                <span className="text">
                    Segunda Feira, 20 de abril de 2026
                </span>
                <HiChevronRight className="icon" />
            </div>

            <div className="div-line">
                <div className="line"></div>
            </div>
        </div>
    )
}

export default Professionals